// destruct unstructures the data from the "ui" format
// categories, handlers etc
const destruct = product => {
  const { options = [], customisations = [], posItemId } = product;
  const reduceOptions = option => {
    return option.products.filter(item => item.selected);
  };

  // The .map added processes customisations within customisations only when the length > 0, specifically for Deliverect.
  // This ensures the required nested properties are included in the order body. For other providers, this has no effect,
  // as customisations are handled by the backend during menu pull, and no additional mapping is necessary.
  const reduceCategories = category => {
    const products = category.products
      .filter(item => item.default || item.selected)
      .map(product => {
        if (product.customisations?.length > 0) {
          return {
            ...product,
            customisations: product.customisations.map(reduceCategories).flat(),
          };
        } else {
          return product;
        }
      });
    return products.map(product => ({ ...product, categoryId: category.categoryId }));
  };

  const opts = options.map(reduceOptions).flat();
  return {
    ...product,
    posItemId,
    options: opts.map(destruct),
    customisations: customisations.map(reduceCategories).flat(),
  };
};

export { destruct };
